<div class="container">
    <div class="row">
        <div class="col-7 mb-1">
            <h3 i18n>Informe de trazabilidad</h3>
        </div>

        <div class="col-12 mb-2">
            <div class="row">
                <div class="col-sm-4 col-md-3">
                    <div class="form">
                        <label for="filterDocument" i18n>Fecha Inicial</label>
                        <input type="date" class="form-control" id="filterDocument" [(ngModel)]="from">
                    </div>
                </div>
                <div class="col-sm-4 col-md-3">
                    <div class="form">
                        <label for="filterDocument" i18n>Fecha Final</label>
                        <input type="date" class="form-control" id="filterDocument" [(ngModel)]="to">
                    </div>
                </div>
                <div class="col-sm-3 col-md-2">
                    <div class="form">
                        <button type="button" class="btn btn-primary btn-filter" (click)="loadTraces()"
                            i18n>Filtrar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-12 mb-3">
        <div class="table-responsive">
            <table class="table table-striped table-bordered">
                <thead>
                    <tr>
                        <th scope="col" i18n>Numero</th>
                        <th scope="col" i18n>Fecha</th>
                        <th scope="col" i18n>Tipo</th>
                        <th scope="col" i18n>Equipo Origen</th>
                        <th scope="col" i18n>Equipo destino</th>
                        <th scope="col" i18n>Usuario</th>
                        <th scope="col" i18n>Aplicación</th>
                        <th scope="col" i18n>Servicio</th>
                        <th scope="col" i18n>Acción</th>
                        <th scope="col" i18n>Resultado</th>
                    </tr>
                </thead>
                <tbody>
                    @for (trace of traces; track trace.number) {
                    <tr class="clickable">
                        <td>{{trace.number}}</td>
                        <td>{{trace.timestamp| date: 'dd/MM/yyyy HH:mm:ss'}}</td>
                        <td>{{trace.value.Type}}</td>
                        <td>{{trace.value.SourceComputer}}</td>
                        <td>{{trace.value.DestinationComputer}}</td>
                        <td>{{trace.value.Username}}</td>
                        <td>{{trace.value.Application}}</td>
                        <td>{{trace.value.Service}}</td>
                        <td>{{trace.value.Action}}</td>
                        <td>{{trace.value.Result}}</td>
                    </tr>
                    } @empty {
                    <tr>
                        <td colspan="9" class="text-center" i18n>No hay trazas</td>
                    </tr>
                    }
                </tbody>
            </table>
        </div>
        <div class="pagination-box">
            <ul class="pagination">
                <li class="page-item" [class.disabled]="page == 1" (click)="page = 1;loadTraces()">
                    <a class="page-link"><<<</a>
                </li>
                <li class="page-item" [class.disabled]="page == 1" (click)="page = page - 1;loadTraces()">
                    <a class="page-link"><</a>
                </li>
                <li class="page-item" *ngFor="let pageNumber of pages" [class.active]="pageNumber === page"
                    (click)="page = pageNumber;loadTraces()"><a class="page-link">{{ pageNumber }}</a></li>
                <li class="page-item" [class.disabled]="page == totalPages" (click)="page = page + 1;loadTraces()"><a
                        class="page-link">></a></li>
                <li class="page-item" [class.disabled]="page == totalPages" (click)="page = totalPages;loadTraces()"><a
                        class="page-link">>>></a></li>
            </ul>
        </div>
    </div>
</div>